<template>
  <div class="el-form-item item">
    <!-- 搜索项 -->
    <el-select v-model="curSearchKey" placeholder="请选择" @change="onKeyChange" filterable>
      <el-option v-for="(n, i) in options" :key="n.label + i" :label="n.label" :value="n.value">
      </el-option>
    </el-select>
    <!-- 搜索框 -->
    <el-input class="val" type="text" placeholder="请填写搜索内容" v-model="curSearchValue" @change="onValueChange"></el-input>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CompositeFormCtrl",
  props: {
    options: Array,
  },
  data() {
    return {
      curSearchKey: undefined,
      curSearchValue: undefined,
    };
  },
  watch: {
    options: {
      deep: true,
      handler(newVal) {
        console.log(newVal, this.options)
        if (newVal && newVal[0]) {
          this.curSearchKey = newVal[0].value
        }
      },
    },
    curSearchKey: {
      deep: true,
      handler(newVal, oldVal) {
        // console.log(newVal, oldVal)
        // 键名变换时重置旧的键值，避免隐性的搜索
        this.$emit("onChange", {
          key: oldVal,
          value: '',
        });
      },
    },
  },
  computed: {
    ...mapState([
      'user',
      'store',
    ]),
  },
  methods: {
    onKeyChange(v) {
      // console.log(v, typeof v);
      this.curSearchKey = v
      this.curSearchValue = undefined
    },
    onValueChange(v) {
      // console.log(this.curSearchKey, v, typeof v);
      this.$emit("onChange", {
        key: this.curSearchKey,
        value: v,
      });
    },
    setNormalKey() {
      if (this.options && this.options[0]) {
        this.curSearchKey = this.options[0].value
      }
    },
    reset() {
      this.setNormalKey()
      this.curSearchValue = undefined
    },
  },
  mounted() {
    // 首先设置默认值
    this.setNormalKey()
    // 获取存储的搜索参数
    // console.log('store', { ...this.store })
    const path = this.$route.path
    if (this.store && this.store['formInline' + path]) {
      const formInline = this.store['formInline' + path]
      this.$forceUpdate()
      // console.log('formInline 1', { ...formInline })
      // console.log('options', this.options)
      this.options.map(v => {
        const key = v.value
        // 匹配数据设置储存的值
        if (Object.hasOwnProperty.call(formInline, key) && formInline[key]) {
          this.curSearchKey = key
          this.curSearchValue = formInline[key]
        }
      })
    }
  },
};
</script>

<style lang="less" scoped>
.el-form-item {
  margin-right: 20px;

  /deep/ .el-select {

    .el-input {
      width: 120px;

      .el-input__inner {
        border-right-width: 0;
        border-radius: 4px 0 0 4px;
        &:focus {
          border-right-width: 1px;
        }
      }
    }
  }

  >.val.el-input {
    width: 200px;
    /deep/.el-input__inner {
      border-radius: 0 4px 4px 0;
    }
  }

}
</style>
